import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { CurrentMentorsActions } from "../actions/currentClientActions";

export default function numberInQueueReducer(
    state = initialState.numberInQueue,
    action: CurrentMentorsActions
): number | null {
    switch (action.type) {
        case types.ENTERED_INTO_QUEUE_SUCCESS:
        case types.CHECK_QUEUE_PLACEMENT_SUCCESS: {
            //avoid showing a sudden larger number in queue so the user doesn't get :(
            if (state !== null && action.queuePlacementResult.placeInQueue > state) {
                return state;
            }
            return action.queuePlacementResult.placeInQueue;
        }
        default:
            return state;
    }
}
